export default "__VITE_ASSET__Cudws$VA__"